import { getResource } from './BaseRequests'


export const fetchReference = (success, fail) => {
    //cache for up to 24 hours
    getResource("reference", {}, 24*60*60).then(results => success(results.categories) ).catch(fail)
}